export const parseStatus = (response: Response) => {
  let {status} = response;

  status = status === 1223 ? 204 : status;

  const success =
    (status >= 200 && status < 300) ||
    status === 304 ||
    (status === 0 &&
      // @ts-expect-error: TODO: describy why
      response._bodyText &&
      // @ts-expect-error: TODO: describy why
      response._bodyText.length > 0);

  let isException = false;

  if (!success) {
    switch (status) {
      case 12002:
      case 12029:
      case 12030:
      case 12031:
      case 12152:
      case 13030:
        isException = true;
        break;
      default:
        break;
    }
  }

  if (isException) {
    // @ts-expect-error: TODO: describy why
    response.status = 0;
    // @ts-expect-error: TODO: describy why
    response.statusText = 'Communication failure';
  }

  return success ? Promise.resolve(response) : Promise.reject(response);
};
